import React from 'react'
import ReactDOM from 'react-dom'

export interface PortalProps {
  container?: HTMLElement
  children?: React.ReactNode
}

export const Portal = (props: PortalProps): React.ReactPortal => {
  const { container = document.body, children } = props
  return ReactDOM.createPortal(children, container)
}
